import React from 'react';
import PropTypes from 'prop-types';
import BaseButton from './BaseButton';
import colors, { tint } from '../../helpers/colors';

const buttonStateStyles = (baseColor) => ({
  hover: {
    backgroundColor: tint(baseColor, 95),
    borderColor: tint(baseColor, 40),
    color: tint(baseColor, 40),
  },
  active: {
    backgroundColor: tint(baseColor, 90),
    borderColor: tint(baseColor, 40),
    color: tint(baseColor, 40),
  },
  focus: {
    backgroundColor: tint(baseColor, 95),
    borderColor: tint(baseColor, 40),
    color: tint(baseColor, 40),
  },
  disabled: {
    borderColor: tint(baseColor, 95),
    backgroundColor: tint(baseColor, 95),
    color: tint(baseColor, 70),
    cursor: 'not-allowed',
  },
  normal: {
    borderColor: tint(baseColor, 40),
    color: tint(baseColor, 40),
    backgroundColor: colors.white,
  },
});

const SecondaryButton = ({
  color,
  isDisabled,
  label,
  onClick,
  className,
  ...props
}) => (
  <BaseButton
    isSecondary
    isDisabled={isDisabled}
    onClick={onClick}
    buttonStateStyles={buttonStateStyles(color)}
    label={label}
    className={className}
    {...props}
  />
);

SecondaryButton.defaultProps = {
  isDisabled: false,
  color: colors.black,
};

SecondaryButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  isDisabled: PropTypes.bool,
  color: PropTypes.oneOf(Object.values(colors)),
};

export default SecondaryButton;
